import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PlanCardClickEvent } from 'src/app/components/new-billing/plan-card/plan-card.component';
import { ConcretePlan } from 'src/app/pages/new-billing/models/plan.model';
import {
    UpgradeDowngradeBaseModel
} from 'src/app/pages/new-billing/models/upgrade-downgrade-model/upgrade-downgrade-base.model';
import {
    UpgradeDowngradeOnPaidModel
} from 'src/app/pages/new-billing/models/upgrade-downgrade-model/upgrade-downgrade-on-paid.model';
import {
    UpgradeDowngradeOnTrialModel
} from 'src/app/pages/new-billing/models/upgrade-downgrade-model/upgrade-downgrade-on-trial.model';
import { PricePeriodicity } from 'src/app/pages/new-billing/types/plan.types';
import { PlanStateService } from 'src/app/services/billing/plan-state.service';
import { RecurrenceStateService } from 'src/app/services/billing/recurrence-state.service';

@Component({
  selector: 'app-upgrade-downgrade-plan',
  templateUrl: './upgrade-downgrade-plan.component.html',
})
export class UpgradeDowngradePlanComponent implements OnInit, OnDestroy {
  @Input()
  set currentPlan(plan: ConcretePlan) {
    this._currentPlan = plan;
    this.upgradeDowngradeModel = plan.subscription.status === 'trial'
      ? new UpgradeDowngradeOnTrialModel(this.injector)
      : new UpgradeDowngradeOnPaidModel(this.injector);
  }

  get currentPlan(): ConcretePlan { return this._currentPlan; }

  @Output()
  planChanged = new EventEmitter<void>();

  @Input() isV2 = false;

  cardPlan: ConcretePlan;
  payRecurrence: PricePeriodicity = 'year';

  private _currentPlan: ConcretePlan;
  private upgradeDowngradeModel: UpgradeDowngradeBaseModel;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private injector: Injector,
    private readonly planStateService: PlanStateService,
    private readonly recurrenceStateService: RecurrenceStateService,
  ) { }

  ngOnInit(): void {
    // Subscribe to shared state changes
    this.recurrenceStateService.payRecurrence$
      .pipe(takeUntil(this.destroy$))
      .subscribe(recurrence => {
        if (this.payRecurrence !== recurrence) {
          this.payRecurrence = recurrence;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public handlePlanChange(event: PlanCardClickEvent) {
    this.planStateService.handlePlanChange(
      event,
      this.upgradeDowngradeModel,
      undefined,
      this.isV2,
    );
  }
}
